/* eslint-disable max-len */
import React, { useRef, useState } from 'react';
import AnimatedModel from '../Animation/AnimatedModel';
import AnimatedHeading from '../Animation/AnimatedHeading';
import UpdateButton from '../UpdateButton';
import { useOnClickOutside } from '../../CommonMethods/OutsideClick';
import AnimatedButton from '../Animation/AnimatedButton';
import TextArea from '../TextArea';

const ConfirmationPrompt = ({handleClose, tittle, message, buttonName, handleOnCLickActivate, loadingActivation, additionalMessage, textMessage, textAreaMsg, setTextAreaMsg, emptyField,setEmptyField,userList,disabled,CancelButton,data_testid}) => {
    const outsideClickRef = useRef();
    useOnClickOutside(outsideClickRef, () => {
        if (!disabled && !loadingActivation) {
            handleClose();
        }
    });

    function handleOnChangeInput(id,value) {
        setTextAreaMsg(value);
        setEmptyField&&setEmptyField(false)
    }

    return (
        <AnimatedModel 
            Children={
                <div data-te-modal-init="" className="fixed left-0 top-0 z-[1055] h-full w-full overflow-y-auto overflow-x-hidden outline-none bg-black bg-opacity-50" id="modalforDeactivate" tabIndex="-1" aria-labelledby="modalforDeactivateTitle" aria-modal="true" role="dialog" data-te-open="true" style={{display: "block"}}>
                    <div ref={outsideClickRef} data-te-modal-dialog-ref="" className="pointer-events-none relative flex min-h-[calc(100%-1rem)] w-auto translate-y-[-50px] items-center opacity-1 transition-all duration-300 ease-in-out min-w-[422px] mx-auto max-w-[422px]">
                        <div className="pointer-events-auto flex w-full flex-col rounded-[16px] border-none bg-white bg-clip-padding text-current shadow-lg outline-none min-w-[422px] mx-auto max-w-[422px] px-4 py-5 relative">
                            <AnimatedHeading className="text-xl font-semibold text-[#000000] text-center" Children={tittle} />
                            <div className="relative pt-[13px]">
                                <AnimatedHeading className="text-center text-[16px] font-normal text-[#000]" Children={additionalMessage} /> 
                                <AnimatedHeading className="text-center text-[16px] font-normal text-[#031624]" Children={message} />
                                {userList!==undefined&& userList.length>0&&<ul className='max-h-[150px] overflow-auto scrollbar_purple'>
                                    {userList?.map((user_name)=>(
                                        <li key={user_name} className='text-center'>
                                            {user_name}
                                        </li>
                                    ))}
                                </ul>}
                                {textAreaMsg!==undefined && !textMessage && <TextArea
                                    htmlFor={'Comment_here'}
                                    id={'Comment_here'}
                                    emptyField={emptyField!==undefined&&emptyField}
                                    value={textAreaMsg}   
                                    isLoading={loadingActivation}                                 
                                    placeholder={'Comment here'}
                                    handleOnChangeInput={handleOnChangeInput}
                                />   
                                }
                                
                            </div>
                            <div className="mt-[13px] w-full">
                                <div className='flex -mx-2.5'>
                                    <div className='px-2.5 w-1/2'>
                                        <button
                                            onClick={() => handleClose()} 
                                            id="Cancel"
                                            data-testid="cancle-btn"
                                            disabled={disabled || loadingActivation}
                                            className="py-2.5 px-4 rounded-[16px] border border-[#972E4C] text-lg font-semibold text-[#972E4C] w-full disabled:cursor-not-allowed" 
                                        > {CancelButton ? 'No' : 'Cancel'}
                                        </button>
                                    </div>
                                    <div className='px-2.5 w-1/2'>
                                        <UpdateButton data_testid={data_testid} loading={loadingActivation} ButtonName={buttonName} handleOnCLick={handleOnCLickActivate} disabled={disabled}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        />
        
    );
}

export default ConfirmationPrompt;
